import React, {useState, useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faPhone} from '@fortawesome/free-solid-svg-icons';
import { faPerson, faPersonDress, faXmark, faCheck } from '@fortawesome/free-solid-svg-icons';

function Fill_IYP({collection}) {

   
    const [loading, setLoading] = useState(false)
     const [check, setCheck] = useState(false)

  

    const checks = () =>{
       
    }

    const go = ({school}) =>{

      collection.setSchool_level(school)
      setCheck(true)

    }


      const scroll = async () =>{

      setLoading(true)

    const loginData = {
       name: collection.name,
       school_level: collection.school_level,
       parent_phone: collection.parent_phone,
       email: collection.email,
       phone: collection.phone,
       alt_phone: collection.alt_phone,
       date: collection.date,
       about_you: collection.about_you,
       unik: collection.timestamp
     
      };

            // Send data to the PHP backend using fetch
            fetch('https://hosteladventures.site//PHP/Opportunites/Scholarship/Fill_in.php', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(loginData)
            })
              .then(response => response.json())
              .then(data => {
                // Handle response from backend (e.g., login success or failure)
                if(data.message=='in')
                {
                  //rock(false)
                  setLoading(false)
                  collection.setSpa_fill(false)
                  collection.setFront_ID(true)
                }
             
              })
              .catch(error => {
                alert.error('Error:', error);
              });
    
  
        
    }


  return (
      <div className='Form_FYP'>
        <p className='fill_In_IYF'>Apply For Scholarship</p>

        <input placeholder='Full Name' onChange={(event) => collection.setName(event.target.value)} />
             <div>
                <p className='Book_STD'>Current/Former education Leve - Click One</p>
                {!check?( <div className='Book_STD_BTNS'>
                   <div onClick={() => go({ school: 'primary'})} className='Book_std_inner_BTN'>Primary</div>
                   <div onClick={() => go({ school: 'secondary'})} className='Book_std_inner_BTN'>Secondary</div>
                   <div onClick={() => go({ school: 'college'})} className='Book_std_inner_BTN'>College</div>
                   <div onClick={() => go({ school: 'university'})} className='Book_std_inner_BTN'>University</div>
                </div>):(<div><button onClick={checks}><FontAwesomeIcon icon={faCheck} /></button></div>)}
               
            </div>
       
            
            <div>
              <div className='DOM_PH'>Former School Complition Year:</div>
              <input type='date' placeholder='date of admission' onChange={(event) => collection.setDate(event.target.value)} />
            </div>
                        
        <input placeholder='Phone Number' onChange={(event) => collection.setPhone(event.target.value)}/>
        <input placeholder='Aternative Phone Number' onChange={(event) => collection.setAltphone(event.target.value)} />
         <input placeholder='Parent/Guardian Number' onChange={(event) => collection.setParent_phone(event.target.value)}/>
        <input placeholder='Email' onChange={(event) => collection.setEmail(event.target.value)} />

         <textarea className='textAr' placeholder='briefley describe your academic and career aspirations - 500 words' onChange={(event) => collection.setAbout_you(event.target.value)}/>

        {!loading?(<div className='submit' onClick={scroll}>Submit</div>):(<div className='submit'>Loading...</div>)}
    </div>
  )
}

export default Fill_IYP
